<template>
  <div :style="conTop">
    <van-row class="p-l-1 p-r-1" style="padding-top:1.15rem">
      <!-- 头部 -->
      <van-col :span="24">
        <div class="van-multi-ellipsis--l2">
          <van-tag
            color="#FFFFFF"
            text-color="#FF8833"
            class="f-s-7 xzTagStyele text-c m-r-8"
            >{{GroupMsg.itname}}</van-tag
          >
          <span class="xz-f-s-1" style="color:#FFFFFF"
            >{{GroupMsg.title}}</span
          >
        </div>
      </van-col>
      <!-- 资料目录 -->
      <van-col :span="24" class="bg-white m-t-07 xzDataCatalog">
        <Catalog :dlist="GroupMsg.dlist" />
      </van-col>
      <!-- 拼团成员 -->
      <van-col :span="24" class="xzGroup bg-white m-t-07 p-t-05">
        <p class="text-c f-s-8">拼团成员</p>
        <van-row>
          <van-col :span="24" class="m-t-07 text-c" >
            <div :style="itemWidth()" style=" margin: 0 auto;">
              <div v-for="(item,index) in GroupMsg.uList.length <= 0 ? GroupMsg.pinnnum : GroupMsg.uList"
                  :key="index" :style="{position:index == 0 ? 'relative' : ''}" class="f-l-l m-l-08">
                <van-image
                  width="2.35rem"
                  height="2.35rem"
                  round
                  :src="item.uid == undefined ? questionMark : item.headimgurl"
                >
                </van-image>
                <van-tag
                  v-if="index == 0"
                  class="f-s-5 text-c Xzjy_chief"
                  color="#F89246"
                  text-color="#FFFFFF"
                  >团长</van-tag
                >
              </div>
            </div>

          </van-col>
        </van-row>
      </van-col>
      <!-- 活动规则 -->
      <van-col :span="24" class="xzRule bg-white m-t-075">
        <Rule />
      </van-col>
    </van-row>
    <!-- 公用底部 -->
    <Footer class="Footer" :GroupMsg="GroupMsg" />
    <Gohome hidden />
  </div>
</template>

<script>

import Footer from "@/components/liveList/BIM/detialsFoot";
import Catalog from "@/components/liveList/BIM/catalog";
import Rule from "@/components/liveList/BIM/rule";
import Gohome from '@/components/gohome/gohome'

export default {
  components: {
    Footer,
    Catalog,
    Rule,
    Gohome
  },
  created(){
    let query = this.$route.query
    if(JSON.stringify(query) == "{}" || query.pid == undefined || query.pid == 'undefined'){
      this.$dialog.alert({
        message: '检测不到当前拼团id',
      }).then(() => {
        this.$router.push("/liveList")
      })
    }else {
      this.groupId = query.pid
      this.getGroupMsg()
    }
    let belong = this.$route.query.belong
    if(this.isNotNull(belong) && belong != this.getLocal('belong')){
      this.setLocal('belong',belong)
    }
    this.isPay = query.isPay
  },
  data() {
    return {
      conTop: {background:"url(" + require("../../../assets/imgs/dataBgImg.png") +") no-repeat",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
      },
      questionMark: require("@/assets/imgs/live/questionMark.png"),
      groupId:"",  // 从链接中获取的拼团的id
      GroupMsg:{
        dlist:[],
        uList:[],
      },
      isPay:false,
    };
  },
  methods:{
    // 用来计算组团的宽度
    itemWidth(){
      let num = this.GroupMsg.uList.length <= 0 ? this.GroupMsg.pinnnum : this.GroupMsg.uList
      let Width = num * (2.35 + 0.8)
      return "width: " +  Width + "rem;height:2.35rem"
    },
    getGroupMsg(){
      let belong = this.$route.query.belongGroupId
      this.Api({
        url:
        belong == undefined ? `api/datumtPinByPid?pid=${this.groupId}` : 
        `api/datumtPinByPid?pid=${this.groupId}&orderGroupId=${belong}`,
        method:'GET'
      }).then(res => {
        if(res.retuCode == 5000){
          if(res.data.uList == null){  // 人数为null
            res.data.uList = []
          }else if(res.data.uList.length < res.data.pinnnum) {  // 如果人数小于拼团总数
            let num = res.data.pinnnum - res.data.uList.length
            for (let index = 0; index < num; index++) {
              res.data.uList.push({})
            }
          }
          this.GroupMsg = res.data
        }else {
          alert("获取拼团信息失败,请联系学习规划老师")
        }
      }).catch(() => {
        alert("拼团未知错误,请联系学习规划老师")
      })
    }
  },
  watch:{
    isPay:{
      deep:true,
      immediate:true,
      handler(val){
        if(val) {
          this.getGroupMsg()
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.loading {
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
}
// 资料目录
.xzDataCatalog {
  border-radius: 0.3rem;
  max-height: 10.75rem;
  padding-top: 0.75rem;
  padding-left: 0.8rem;
  padding-right: 0.75rem;
  padding-bottom: 0.4rem;
}
// 活动规则
.xzRule {
  border-radius: 0.3rem;
  padding: 0.5rem 0.8rem 0.5rem 1.05rem;
}
.xzGroup {
  border-radius: 0.3rem;
  padding-bottom: 0.5rem;
}
// 标签样式
.xzTagStyele {
  // width: 1.9rem;
  height: 1.1rem;
  line-height: 1.1rem;
}
.Footer {
  position: fixed;
  bottom: 0px;
  width: 100%;
}
// 团长样式
.Xzjy_chief {
  position: absolute;
  left: 0.2rem;
  top: 1.8rem;
  width: 1.5rem;
  height: 0.8rem;
  line-height: 0.8rem;
  display: block;
  border-radius: 0.45rem;
}
</style>
